import 'apps/pathways/styles/app/main/landing.scss';
import React from 'react';
import { Link } from 'library/util/core-router';
import MountainsSvg from 'apps/pathways/icons/mountains.svg';
import BalloonSvg from 'apps/pathways/icons/balloon.svg';
import { LogoSvg } from 'library/components/logo';
import CloudSvg from 'apps/pathways/icons/cloud.svg';

import { lighten } from 'library/util/css';

class Balloon extends React.Component {
  state = {
    left: 0,
    top: 0,
    modifier: 0,
    topModifier: 0
  }

  componentDidMount() {
    const modifier = Math.random();
    this.setState({
      modifier: modifier,
      left: -(this.props.width || 58),
      top: this.props.containerHeight * Math.min(modifier, 0.5),
      topModifier: (Math.random()*0.1) - 0.05
    });

    this.recalculatePosition(this.props);
    this._isMounted = true;

    this.startTransition();

    window.addEventListener('resize', this.handleRecalculate);
  }

  startTransition = () => {
    window.requestAnimationFrame(this.translate);
  }

  translate = (timestamp) => {
    if (!this._isMounted) return;

    if (!this.lastTimestamp) {
      this.lastTimestamp = timestamp;
    }

    const {
      top,
      left,
      modifier,
      topModifier
    } = this.state;

    const timePassed = timestamp - this.lastTimestamp;
    const width = this.props.containerWidth;

    let newTop = top + (timePassed * 0.05 * (topModifier * modifier));
    let newLeft = left + (timePassed * 0.05) * Math.max(0.3, modifier);

    if (newLeft > width) {
      this.setState({
        left: -(this.props.width || 58),
        modifier: Math.random(),
        top: this.props.containerHeight * Math.min(modifier, 0.5),
        topModifier: (Math.random()*0.1) - 0.05
      })
    } else {
      this.setState({
        left: newLeft,
        top: newTop
      })
    }

    if (Math.random() < 0.005 * modifier) {
      this.setState({
        topModifier: (Math.random()*0.1) - 0.05
      });
    }

    this.lastTimestamp = timestamp;

    window.requestAnimationFrame(this.translate);
  }

  componentWillUnmount() {
    this._isMounted = false;

    window.removeEventListener('resize', this.handleRecalculate);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.containerHeight !== this.props.containerHeight || nextProps.containerWidth !== this.props.containerWidth) {
      this.recalculatePosition(nextProps);
    }
  }

  handleRecalculate = () => {
    this.recalculatePosition(this.props);
  }

  recalculatePosition = (props, state) => {
    this.setState({
      top: props.containerHeight * Math.min(this.state.modifier, 0.5)
    })
  }

  render() {
    const {
      containerHeight,
      containerWidth,
      ...props
    } = this.props;
    const {
      top,
      left,
      modifier
    } = this.state;

    return (
      <BalloonSvg style={{top: 0, left: `-${(this.props.width||58)}px`, transform: `translateX(${left}px) translateY(${top}px)`, zIndex: Math.floor(modifier * 10)}} {...props} />
    );
  }
}

class Clouds extends React.Component {
  state = {
    clouds: []
  }

  componentWillMount() {
    this.setState({
      clouds: (new Array(Math.floor(Math.random() * 3) + 3)).fill(null).map(c=>({
        ...this.randomCloud(),
        left: Math.floor(Math.random() * window.innerWidth)
      }))
    });
  }

  get containerHeight() {
    if (this.refs.container) {
      return this.refs.container.offsetHeight
    }
    return 0;
  }

  get containerWidth() {
    if (this.refs.container) {
      return this.refs.container.offsetWidth;
    }
    return 0;
  }

  componentDidMount() {
    this.recalculatePosition();
    this._isMounted = true;
    this.startTransition();

    window.addEventListener('resize', this.recalculatePosition);
  }

  componentWillUnmount() {
    this._isMounted = false;

    window.removeEventListener('resize', this.recalculatePosition);
  }

  recalculatePosition = () => {
    let { clouds } = this.state;

    this.setState({
      clouds: clouds.map(c=>({
        ...c,
        top: Math.floor(c.topModifier * this.containerHeight)
      }))
    })
  }

  startTransition = () => {
    window.requestAnimationFrame(this.translate);
  }

  translate = (timestamp) => {
    if (!this._isMounted) return;

    if (!this.lastTimestamp) {
      this.lastTimestamp = timestamp;
    }
    const timePassed = timestamp - this.lastTimestamp;
    const width = this.containerWidth;

    const clouds = this.state.clouds.map(c=>({
      ...c,
      left: c.left + (timePassed * 0.01) * Math.max(0.3, c.scale)
    })).filter(c=>c.left < width)

    if (Math.random() < 0.01 && clouds.length <= 6) {
      clouds.push(this.randomCloud())
    }

    this.setState({
      clouds: clouds
    })

    this.lastTimestamp = timestamp;

    window.requestAnimationFrame(this.translate);
  }

  randomCloud = () => {
    const topModifier = Math.max(0.2, Math.min(Math.random(), 0.5));
    const scale = Math.random();
    const width = (scale * 350) + 50

    return {
      scale: scale,
      width: width,
      height: width * 0.45724907063197,
      topModifier: topModifier,
      left: -(width),
      top: Math.floor(topModifier * this.containerHeight),
      color: lighten('#004A5E', Math.max(0.3, scale))
    }
  }

  mapClouds = ({ scale, top, left, width, height, color }) => {
    return <CloudSvg className="pathways-landing-cloud" style={{width: `${width}px`, height: `${height}px`, top: `${top}px`, transform: `translateX(${left}px)`, color: color, zIndex: Math.floor(scale*10)}} />;
  }

  render() {
    return (
      <div ref="container" {...this.props}>
        {
          this.state.clouds.map(this.mapClouds)
        }
        <Balloon containerHeight={this.containerHeight} containerWidth={this.containerWidth} className="pathways-landing-balloon" />
      </div>
    )
  }
}

export default class PathwaysLanding extends React.Component {
  render() {
    return (
      <div className="pathways-landing">
        <section className="pathways-landing-masthead">
          <div className="pathways-landing-masthead-title">
            <LogoSvg />
            <h1>
              <small>PAIRIN</small>
              PATHWAYS
            </h1>
          </div>
          <h2>The first <strong>non-linear</strong> personalized career exploration tool</h2>
          <div className="pathways-landing-masthead-buttons">
            <a className="button button-outline-white" href={`${__ACCOUNT_URL__}/auth/signin?continue=${__APPURL__}/pathways`}>Sign In</a>
          </div>
        </section>
        <div className="pathways-landing-background">
          <div className="pathways-landing-background-masthead">
            <Clouds className="pathways-landing-clouds" />
            <MountainsSvg className="pathways-landing-mountains" />
          </div>
        </div>
      </div>
    );
  }
}
